import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'

import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white',

    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow',
    })
}


function Iframe(props) {
    console.log("URL Calling : ", props.src)
    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}



const firstDate = new Date();
const currentDate = new Date();

const current = new Date();

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

class FleetOverViewFleetSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fodata: {},

            timeFrameDropDownOptionsNew: [
                { value: 0, label: monthNames[current.getMonth()]},
                { value: 1, label: monthNames[current.getMonth()-1] },
                { value: 2 , label: monthNames[current.getMonth()-2] },
                { value: 3, label: monthNames[current.getMonth()-3] }
            ],


            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),

            srcURL_Shell_Card_Transaction_Value_In_Litre_Pie: '',
            srcURL_Shell_Card_Transaction_Value_In_PKR_Pie: '',
            srcURL_Total_KMs_Travelled_Pie: '',
            srcURL_Total_Driven_Hours_Pie: '',
            srcURL_Average_Shell_Card_Mileage_Pie: '',


            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',

            searchCriteria1: 'vrn',
            Option1: 'vrn',
            Group1: '0',
            Group1Id: '',
            Vehicle1: '',
            Vehicle1Id: '',
            TimeFrameId1: 0,

        };

        this.optionChange1 = this.optionChange1.bind(this)
        this.groupChange1 = this.groupChange1.bind(this)
        this.vehicleChange1 = this.vehicleChange1.bind(this)

        this.changeOptionTime1 = this.changeOptionTime1.bind(this)
    }

    /*Start:For Pie Chart*/
    async changeOptionTime1(selectedOption) {

        await this.setState({ TimeFrameId1: selectedOption.value })

        this.bindAllPieChart();
    }

    async optionChange1(selectedOption) {

        if (selectedOption == 1) {
            await this.setState({ searchCriteria1: "vrn" })
            this.bindAllPieChart();
        }
        else
            await this.setState({ Option1: selectedOption, Group1: 0, Vehicle1: 0 })
    }

    async vehicleChange1(selectedVehicle) {


        await this.setState({ Vehicle1: selectedVehicle, Group1: 0 })

    }

    async groupChange1(selectedGroup) {
        console.log("Selected group are : ", selectedGroup)

        await this.setState({ searchCriteria1: "vrngroup", VRNGroupMasterId: selectedGroup })
        this.bindAllPieChart();

    }

    /*End: For Pie Chart*/

    componentDidMount() {

        this.bindAllPieChart();
    }

    async changeOptionTime(selectedOption) {
        await this.setState({ TimeFrameId: selectedOption.value })
    }

    async bindAllPieChart() {

        /*In Liter*/
        let MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "PieChart_ShellCardLPKR";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=L&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=L&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        await this.setState({ srcURL_Shell_Card_Transaction_Value_In_Litre_Pie: ReportFullURL, showReport: true })

        /*In PKTimeFrameId1R*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardLPKR";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=PKR&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=PKR&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Shell_Card_Transaction_Value_In_PKR_Pie: ReportFullURL, showReport: true })

        /*Total KMs Travelled*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardKmHr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=Km&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=Km&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Total_KMs_Travelled_Pie: ReportFullURL, showReport: true })

        /*Total Driven Hours*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardKmHr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=Hr&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=Hr&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Total_Driven_Hours_Pie: ReportFullURL, showReport: true })

        /*Average Shell Card Mileage (KM/L)*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardKmPerLtr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Average_Shell_Card_Mileage_Pie: ReportFullURL, showReport: true })
    }

    render() {

        return (

            <div>
                <Container>
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Fleet Summary</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptionsNew}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime1}
                                                    defaultValue={{ label: monthNames[current.getMonth()], value: 0 }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">

                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    onOptionChange={this.optionChange1}
                                                    onGroupChange={this.groupChange1}
                                                    onVehicleChange={this.vehicleChange1}
                                                />
                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-md-12 p-0 pr-2">
                                            <Card>

                                                <Card.Body className="p-0">
                                                    <div className="tab-pane active" id="pieTab" role="tabpanel" aria-labelledby="home-tab-justified">


                                                        <Row>
                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Shell_Card_Transaction_Value_In_Litre_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Shell_Card_Transaction_Value_In_PKR_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Total_KMs_Travelled_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Total_Driven_Hours_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Average_Shell_Card_Mileage_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                        </Row>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>

 
               </Container>
            </div>
        );
    }
}

export default FleetOverViewFleetSummary;
